const PreTestCommonConstants = {
  SET_DISPLAY_MODE: 'SET_DISPLAY_MODE',
  SHOW_OVERLAY: 'SHOW_OVERLAY',
  SET_CONTENT_ID: 'SET_CONTENT_ID'
};

const setDisplayMode = (payload) => {
  return { type: PreTestCommonConstants.SET_DISPLAY_MODE, payload };
};

const showOverlay = (payload) => {
  return { type: PreTestCommonConstants.SHOW_OVERLAY, payload };
};

const setContentId = (payload) => {
  return { type: PreTestCommonConstants.SET_CONTENT_ID, payload };
};

export default {
  PreTestCommonConstants,
  setDisplayMode,
  showOverlay,
  setContentId
};
